export interface HudStatusFlags {
  critical: boolean
  superReady: boolean
  guardDanger: boolean
  staminaLow: boolean
}

function finite(value: number): boolean {
  return Number.isFinite(value)
}

export function hudMeterPercent(value: number, max: number): number {
  if (!finite(value) || !finite(max) || max <= 0) return 0
  return Math.max(0, Math.min(100, (value / max) * 100))
}

export function hudAriaMax(max: number): number {
  return finite(max) && max > 0 ? max : 0
}

export function hudAriaValue(value: number, max: number): number {
  if (!finite(value) || !finite(max) || max <= 0) return 0
  return Math.round(Math.max(0, Math.min(max, value)))
}

export function hudStatusFlags(
  health: number,
  maxHealth: number,
  superMeter: number,
  guardMeter: number,
  stamina: number,
): HudStatusFlags {
  const healthValid = finite(health) && finite(maxHealth) && health >= 0 && maxHealth > 0
  const superValid = finite(superMeter) && superMeter >= 0
  const guardValid = finite(guardMeter) && guardMeter >= 0
  const staminaValid = finite(stamina) && stamina >= 0

  return {
    critical: healthValid && health > 0 && health / maxHealth <= 0.25,
    superReady: superValid && superMeter >= 100,
    guardDanger: guardValid && guardMeter > 0 && guardMeter <= 25,
    staminaLow: staminaValid && stamina < 20,
  }
}

export function formatHudTimer(timer: number): string {
  if (!finite(timer) || timer < 0) return '--'
  return Math.ceil(timer).toString().padStart(2, '0')
}
